var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconPremiumSendReceive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.275,
    y1: -0.067,
    x2: 1,
    y2: 1.132,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b246a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37c7f0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    "data-name": "Union 4",
    d: "M5575,3857a27,27,0,1,1,27,27A27,27,0,0,1,5575,3857Zm11.579-15.42A21.808,21.808,0,0,0,5602,3878.808a21.9,21.9,0,0,0,6.25-.9v-20.057l-7.842,7.841-2.667-2.667,12.395-12.4,12.395,12.4-2.667,2.667-7.842-7.84v18.531a21.821,21.821,0,0,0-15.846-40.406v20.284l7.842-7.842,2.669,2.668-12.4,12.395-12.394-12.395,2.666-2.668,7.842,7.84V3837.4A21.82,21.82,0,0,0,5586.58,3841.579Z",
    transform: "translate(-5575.001 -3830)",
    fill: "url(#linear-gradient)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPremiumSendReceive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-premium-send-receive.bacba6ab.svg";
export { ForwardRef as ReactComponent };